import { useState } from 'react'
import { Dialog } from './Dialog'
import { TextField } from '@mui/material'
import { textFieldStyle } from '../utils/constants'
import { sendInvite } from '../api'

export const InviteDialog = ({onSubmit, onClose}: {onSubmit: Function, onClose: Function}) => {
  const [firstName, setFirstName] = useState<string>("")
  const [email, setEmail] = useState<string>("")

  const handleSubmit = async () => {
    await sendInvite({
      inviteeFirstName: firstName,
      inviteeEmail: email,
    })
    onSubmit()
  }

  return (
    <Dialog
      title={'Got someone who you think would be a great addition to the Habits Game?'}
      hasSubmitButton={true}
      submitText="🚀 Send invite email"
      closeText="Cancel"
      onSubmit={handleSubmit}
      isSubmitDisabled={firstName === "" || email === ""}
      onClose={onClose}
    >
      <p>Enter their info below and we'll send them an invite on your behalf!</p>
      <TextField
        placeholder="Their first name"
        style={textFieldStyle}
        onChange={e => setFirstName(e.target.value)}
      />

      <TextField
        placeholder="Their email"
        style={textFieldStyle}
        onChange={e => setEmail(e.target.value)}
      />
    </Dialog>
  )
}
